import { render, staticRenderFns } from "./MatchDialog.vue?vue&type=template&id=070e6ae8&"
import script from "./MatchDialog.vue?vue&type=script&lang=js&"
export * from "./MatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports